module.exports = __webpack_public_path__ + "img/car_0003.943f4346.jpg";